<!-- 专栏首页 -->
<template>
	<div class="column-index">
		<div class="search">
			<van-search placeholder="请输入搜索关键词" v-model="searchKeyWord" @search="goSearch"/>
		</div>
		<!-- 轮播图 -->
		<banner :type="type"></banner>
		<div class="attention" v-if="followColumns.length>0">
			<h3>我的关注</h3>
			<div class="container-wrap">
				<div class="container">
					<div class="item float-left" v-for="(item,index) in followColumns" :key="index" @click="skipColumnDetails(item.id)">
						<img :src="item.banner" alt="">
					</div>														
				</div>
			</div>
		</div>
		<div class="hr-7" v-if="followColumns.length>0"></div>
		<div class="specialColumn" v-if="columnList.length>0">
			<h3>专栏</h3>
			<div class="container">
				<van-list
						v-model="loading.pullUp"
						:finished="finished.list"
						finished-text="没有更多了"
						@load="pullUpLoading"
						class="van-clearfix"
						
				>
					<column-item-list :columnList="columnList"></column-item-list>
				</van-list>
				
			</div>
		</div>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>

    import Tabbar from "../../components/Tabbar";
	import ColumnItemBlock from "../../components/ColumnItemBlock";
	import ColumnItemList from "../../components/ColumnItemList"
    import Banner from "../../components/Banner"
    import {ModulesRecommend,ColumnMyfollow,ColumnList} from "../../config/interface.js"
	export default{
		components:{
    		Tabbar,
    		ColumnItemBlock,
			Banner,
			ColumnItemList
		},
		data(){
			return{
				type:1,   //1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块
				index:2,       //tabbar的index值
				swiperOption: {
					direction: 'horizontal',
	                loop: true,
	                autoplay: 3000,
	                slidesPerView: "auto",
	                centeredSlides:true,
	                spaceBetween: 10,
			        pagination: {
			            el: '.swiper-pagination',
			            clickable: true
			        }
        		},
        		swiperImg:[],           //轮播图
        		followColumns:[], 		//关注的专栏
        		columnList:[],			//专栏列表
				searchKeyWord:'',       //关键词
				finished:{
					list:false,
				},
				loading:{
					pullUp:false
				},
				page:1,
				limit:6
			}
		},
		mounted(){
			this.getSwiper();
			this.myFollowColumn();
			this.getColumns();
		},
		methods:{
			//轮播图
			getSwiper(){
				this.$store.dispatch('isShowLoading',true);
				const url=ModulesRecommend;
				const method='POST';
				let params={
					module_id:1 //专栏模块
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			//我关注的模块
			myFollowColumn(){
				const url=ColumnMyfollow;
				const method='POST';
				let params={
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.followColumns=data;
					}
				})
			},
			//专栏列表
			getColumns(){
				const url=ColumnList;
				const method='POST';
				let params={
					limit:this.limit,
					page:this.page
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let follows=data.follows;
						let columnList=[];
						// this.columnList=data.columns.data;
						this.loading.pullUp = false;
						data.columns.data.forEach((item,index)=>{
							item.follow_total=follows[item.id];
							this.columnList.push(item);
						})
						if(data.columns.data.length<this.limit){
							this.finished.list=true;
						}
					}
				})
			},
			//跳转到专栏详情
			skipColumnDetails(id){
				this.$router.push({
					path:'/column/details',
					query:{
						id:id
					}
				})
			},
			//去搜索
			goSearch(){
				this.$router.push({
					path:'/column/search',
					query:{
						searchKeyWord:this.searchKeyWord
					}
				})
			},
			//上拉加载
			pullUpLoading(){
				setTimeout(() => {
					this.page++;
					console.log(this.page)
			        this.getColumns();
			      }, 500);
			}

		}
	}
</script>
<style lang="scss">
	.column-index{
		/*搜索*/
		.search{
			.van-search__content{
				background: #F2F2F2;
				border: 1px solid #D3D3D3;
				border-radius: 20px;
				::-webkit-input-placeholder,i{
					color:#999;
					font-size:14px;
				}
				i{
					font-size:20px;
				}
			}
			
		}
		/*轮播图*/
		.swiper-img{
			img{
				width:100%;
			}
		}
		h3{
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;
		    line-height:30px;
		}	
		/*关注	*/
		.attention{
			padding:15px;
			.container-wrap{
				margin-top:10px;
				overflow:hidden;
			}
			.container{
				overflow:auto;
				width:100%;
				@include flex(row);
				.item{
					margin-right:6px;
					img{
						width:113px;
						height:70px;
					}
				}
			}
		}
		/*专栏*/
		.specialColumn{
			padding:15px;
			margin-bottom:50px;
			.container{
			}
		}

	}
</style>


// WEBPACK FOOTER //
// src/pages/Column/Index.vue